import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const User_2: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path d="M275.92 138.68a64.41 64.41 0 01-64.41 64.41h-1.2A64.41 64.41 0 01178 83.68a64.42 64.42 0 0197.94 55z" />
				<path d="M341.4 350.93H81.62a129.87 129.87 0 01126.83-129.86h3.06c3.25 0 6.48.12 9.67.36a130 130 0 01111 81.37q2.25 5.61 4 11.48a129.83 129.83 0 015.22 36.65z" />
			</svg>
		</animated.span>
	)
}

export { User_2 }
